export default __webpack_public_path__ + "static/media/shop-categories-img02.c57b24ec.jpg";